/**
 * Request message for POST /token
 */ export var BackendId;
(function(BackendId) {
    BackendId["Local"] = "Local";
    BackendId["LDAP"] = "LDAP";
    BackendId["OIDC"] = "OIDC";
})(BackendId || (BackendId = {}));
export var VMQueryResponseStatus;
(function(VMQueryResponseStatus) {
    VMQueryResponseStatus["success"] = "success";
    VMQueryResponseStatus["error"] = "error";
})(VMQueryResponseStatus || (VMQueryResponseStatus = {}));
export var NodeType;
(function(NodeType) {
    NodeType["QEA"] = "QEA";
    NodeType["AIAppliance"] = "AIAppliance";
})(NodeType || (NodeType = {}));
export var ServerStatus;
(function(ServerStatus) {
    ServerStatus["Unknown"] = "Unknown";
    ServerStatus["Ok"] = "Ok";
    ServerStatus["NotConfigured"] = "NotConfigured";
    ServerStatus["MalformedConfig"] = "MalformedConfig";
})(ServerStatus || (ServerStatus = {}));
export var SystemState;
(function(SystemState) {
    SystemState["Uninitialized"] = "Uninitialized";
    SystemState["Sealed"] = "Sealed";
    SystemState["Unsealed"] = "Unsealed";
    SystemState["Corrupted"] = "Corrupted";
    SystemState["ExpiredLicense"] = "ExpiredLicense";
})(SystemState || (SystemState = {}));
export var HwOffload;
(function(HwOffload) {
    HwOffload["No"] = "No";
    HwOffload["Crypto"] = "Crypto";
    HwOffload["Yes"] = "Yes";
    HwOffload["Packet"] = "Packet";
    HwOffload["Auto"] = "Auto";
})(HwOffload || (HwOffload = {}));
export var IkeSAState;
(function(IkeSAState) {
    IkeSAState["CREATED"] = "CREATED";
    IkeSAState["CONNECTING"] = "CONNECTING";
    IkeSAState["ESTABLISHED"] = "ESTABLISHED";
    IkeSAState["PASSIVE"] = "PASSIVE";
    IkeSAState["REKEYING"] = "REKEYING";
    IkeSAState["REKEYED"] = "REKEYED";
    IkeSAState["DELETING"] = "DELETING";
    IkeSAState["DESTROYING"] = "DESTROYING";
    IkeSAState["CHILDLESS"] = "CHILDLESS";
    IkeSAState["INACTIVE"] = "INACTIVE";
    IkeSAState["UNKNOWN"] = "UNKNOWN";
})(IkeSAState || (IkeSAState = {}));
export var ChildSAState;
(function(ChildSAState) {
    ChildSAState["CREATED"] = "CREATED";
    ChildSAState["ROUTED"] = "ROUTED";
    ChildSAState["INSTALLING"] = "INSTALLING";
    ChildSAState["INSTALLED"] = "INSTALLED";
    ChildSAState["UPDATING"] = "UPDATING";
    ChildSAState["REKEYING"] = "REKEYING";
    ChildSAState["REKEYED"] = "REKEYED";
    ChildSAState["RETRYING"] = "RETRYING";
    ChildSAState["DELETING"] = "DELETING";
    ChildSAState["DELETED"] = "DELETED";
    ChildSAState["DESTROYING"] = "DESTROYING";
    ChildSAState["INACTIVE"] = "INACTIVE";
    ChildSAState["UNKNOWN"] = "UNKNOWN";
})(ChildSAState || (ChildSAState = {}));
export var IpsecOffloadState;
(function(IpsecOffloadState) {
    IpsecOffloadState["FullPacketOffload"] = "FullPacketOffload";
    IpsecOffloadState["CryptoOffload"] = "CryptoOffload";
    IpsecOffloadState["NoOffload"] = "NoOffload";
    IpsecOffloadState["TunnelNotFound"] = "TunnelNotFound";
    IpsecOffloadState["PartialSaOffload"] = "PartialSaOffload";
})(IpsecOffloadState || (IpsecOffloadState = {}));
export var QryptErrorCode;
(function(QryptErrorCode) {
    QryptErrorCode["EntropyStore"] = "EntropyStore";
    QryptErrorCode["EntropyStream"] = "EntropyStream";
    QryptErrorCode["EntropyLog"] = "EntropyLog";
    QryptErrorCode["ConfigBuildError"] = "ConfigBuildError";
    QryptErrorCode["StartupError"] = "StartupError";
    QryptErrorCode["RedisError"] = "RedisError";
    QryptErrorCode["Permissions"] = "Permissions";
    QryptErrorCode["DbProvider"] = "DbProvider";
    QryptErrorCode["Swanctl"] = "Swanctl";
    QryptErrorCode["ViciCommandFailed"] = "ViciCommandFailed";
    QryptErrorCode["ViciError"] = "ViciError";
    QryptErrorCode["ViciBrokenPipe"] = "ViciBrokenPipe";
    QryptErrorCode["HwOffload"] = "HwOffload";
    QryptErrorCode["SeedOperationError"] = "SeedOperationError";
    QryptErrorCode["ConfigUpdateError"] = "ConfigUpdateError";
    QryptErrorCode["HsmSessionError"] = "HsmSessionError";
    QryptErrorCode["ValidationError"] = "ValidationError";
    QryptErrorCode["TOMLDeserializationError"] = "TOMLDeserializationError";
    QryptErrorCode["TOMLSerializationError"] = "TOMLSerializationError";
    QryptErrorCode["CryptokiError"] = "CryptokiError";
    QryptErrorCode["ExistingSeed"] = "ExistingSeed";
    QryptErrorCode["NotReady"] = "NotReady";
    QryptErrorCode["UreqError"] = "UreqError";
    QryptErrorCode["MetricsApiError"] = "MetricsApiError";
    QryptErrorCode["Auth"] = "Auth";
    QryptErrorCode["Unauthorized"] = "Unauthorized";
    QryptErrorCode["BackendNotConnected"] = "BackendNotConnected";
    QryptErrorCode["Jwt"] = "Jwt";
    QryptErrorCode["Utf8"] = "Utf8";
    QryptErrorCode["BadRefreshToken"] = "BadRefreshToken";
    QryptErrorCode["Middleware"] = "Middleware";
    QryptErrorCode["Forbidden"] = "Forbidden";
    QryptErrorCode["PasswordHashing"] = "PasswordHashing";
    QryptErrorCode["RsaKeystore"] = "RsaKeystore";
    QryptErrorCode["Kek"] = "Kek";
    QryptErrorCode["BadUnsealKey"] = "BadUnsealKey";
    QryptErrorCode["BadRootKey"] = "BadRootKey";
    QryptErrorCode["KvDbRecord"] = "KvDbRecord";
    QryptErrorCode["AlreadyInitialized"] = "AlreadyInitialized";
    QryptErrorCode["FailedInit"] = "FailedInit";
    QryptErrorCode["IoError"] = "IoError";
    QryptErrorCode["SerdeError"] = "SerdeError";
    QryptErrorCode["LocalIpAddress"] = "LocalIpAddress";
    QryptErrorCode["DownloadCardStatusError"] = "DownloadCardStatusError";
    QryptErrorCode["GeneralRelativityError"] = "GeneralRelativityError";
    QryptErrorCode["NotFound"] = "NotFound";
    QryptErrorCode["Chrono"] = "Chrono";
    QryptErrorCode["Uuid"] = "Uuid";
    QryptErrorCode["SystemState"] = "SystemState";
    QryptErrorCode["Unknown"] = "Unknown";
    QryptErrorCode["KeyStoreFull"] = "KeyStoreFull";
    QryptErrorCode["MetadataPostError"] = "MetadataPostError";
    QryptErrorCode["KeyGenerationError"] = "KeyGenerationError";
    QryptErrorCode["Internal"] = "Internal";
    QryptErrorCode["Rng"] = "Rng";
    QryptErrorCode["InconsistentState"] = "InconsistentState";
    QryptErrorCode["DataCorrupted"] = "DataCorrupted";
    QryptErrorCode["UnknownClusterNode"] = "UnknownClusterNode";
    QryptErrorCode["Cluster"] = "Cluster";
    QryptErrorCode["CommandStatusStream"] = "CommandStatusStream";
})(QryptErrorCode || (QryptErrorCode = {}));
